const p = /\d+x\d+/

export default function transformSize(size: SlotSize): SlotSize {
    if (Array.isArray(size)) {
        /* tslint:disable:no-any */
        return (size as any[]).map(transformSize) as SlotSize
        /* tslint:enable:no-any */
    }
    if (size.match && size.match(p)) {
        return size.split('x').map(Number)
    }
    return size as SlotSize
}
